import React, { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Icon, Table } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { CoolFarmOptionsContext } from '../../..'

interface Props {
  index: number
  id: string
  removeFeed: (index: number) => void
}

const AvgCrop: React.FC<Props> = ({ index, id, removeFeed }) => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const options = useContext(CoolFarmOptionsContext)

  const cropOptions = options?.crops?.map(crop => ({
    key: crop.id,
    value: crop.id,
    text: crop.name
  })) || []

  return (
    <Table.Row key={id}>
      <Table.Cell>
        <FormFields.Select
          control={control}
          name={`crops[${index}].id`}
          options={cropOptions}
          rules={{ required: true }}
          search
          placeholder={t('Select feed')}
          withoutLabel
          noErrorMessage
        />
      </Table.Cell>
      <Table.Cell>
        <FormFields.Input
          control={control}
          name={`crops[${index}].percent`}
          rules={{ required: true }}
          placeholder={t('Enter value')}
          typeInput='controled'
          allowDecimals
          decimalScale={2}
          withoutAsterisk
          noErrorMessage
        />
      </Table.Cell>
      <Table.Cell textAlign='center'>
        <Icon
          name='trash'
          color='red'
          style={{ cursor: 'pointer', fontSize: '1.2em' }}
          onClick={() => removeFeed(index)}
        />
      </Table.Cell>
    </Table.Row>
  )
}

export default AvgCrop